import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import SimplePharmacyCalendar from './SimplePharmacyCalendar';
import { MultiCalendarSelectionType } from './MultiCalendar';
import { AuthenticationStore } from '../../../store/AuthenticationStore';
import { Instance } from 'mobx-state-tree';
import { inject, observer } from 'mobx-react';
import { PharmacyStore, SecretariatStore, UiStore, UserStore } from '../../../store';
import { DutyToSendToAnotherCalendar } from '../../../store/interfaces/DutyToSend';
import { PharmacyDetails } from '../../../store/models';
import { number } from 'mobx-state-tree/dist/internal';
import { DataGrid } from 'devextreme-react';

export interface MultiCalendarsForComparisonProps extends WithTranslateProps {
  startingPharmacy?: number;
  startingSecondPharmacy?: number;
  onFirstPharmacyIdChanged?: (pharmacyId: number) => void;
  onSecondPharmacyIdChanged?: (pharmacyId: number) => void;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  UiStore?: Instance<typeof UiStore>;
  UserStore?: Instance<typeof UserStore>;
}

export interface MultiCalendarsForComparisonState {
  selectedYear?: number;
  selectedType?: MultiCalendarSelectionType;
  dutyToSendToAnotherCalendar?: DutyToSendToAnotherCalendar;
  firstPharmacyBusyDates?: Array<Date>;
  secondPharmacyBusyDates?: Array<Date>;
  startingPharmacy: number | undefined;
  startingSecondPharmacy: number | undefined;
}

@inject('AuthenticationStore')
@inject('PharmacyStore')
@inject('SecretariatStore')
@inject('UiStore')
@inject('UserStore')
@observer
class MultiCalendarsForComparison extends React.Component<
  MultiCalendarsForComparisonProps,
  MultiCalendarsForComparisonState
> {
  state = {
    selectedYear: new Date().getFullYear(),
    selectedType: undefined,
  } as MultiCalendarsForComparisonState;

  async componentDidMount() {
    this.props.SecretariatStore!.checkListLoaded();
    this.props.PharmacyStore!.checkListLoaded();
    await this.props.UserStore!.checkListLoaded();
  }

  onTypeChange = (type: MultiCalendarSelectionType) => {
    if (this.state.selectedType !== type) {
      this.setState({ selectedType: type });
    }
  };

  onCalendarMove = (fly: number, sly: number) => {
    if (this.state.selectedYear !== fly) {
      this.setState({ selectedYear: fly });
    }
  };

  onDutySentToPharmacy = (date: Date, dutyType: 'NIGHT' | 'DAY' | 'DAYNIGHT', pharmacyId: number) => {
    this.setState({ dutyToSendToAnotherCalendar: { FromPharmacyId: pharmacyId, Date: date, DutyType: dutyType } });
  };

  eraseDutyToSendToAnotherCalendar = () => {
    this.setState({ dutyToSendToAnotherCalendar: undefined });
  };

  setFirstPharmacyBusyDates = (dates: Date[]) => {
    this.setState({ firstPharmacyBusyDates: dates });
  };

  setSecondPharmacyBusyDates = (dates: Date[]) => {
    this.setState({ secondPharmacyBusyDates: dates });
  };

  setStartingPharmacy = (pharmacyId: number) => {
    this.setState({ startingPharmacy: pharmacyId });
  };

  setStartingSecondPharmacy = (pharmacyId: number) => {
    this.setState({ startingSecondPharmacy: pharmacyId });
  };

  changeSecondPharmacy = (pharmacyId: number | undefined, isFromFirstCalendar: boolean) => {
  console.log('début du process');

  if (isFromFirstCalendar) {
      this.setState({
        startingSecondPharmacy: pharmacyId
      });
    } else {
      this.setState({
        startingPharmacy: pharmacyId
      });
    }
};


  render() {
    return (
      <div>
        <SimplePharmacyCalendar
          pharmacyId={this.state.startingPharmacy}
          hideLegend={true}
          synchronizedScrolling={true}
          fly={this.state.selectedYear}
          onCalendarMove={this.onCalendarMove}
          onTypeChange={this.onTypeChange}
          selectedType={this.state.selectedType}
          separateToolbox={true}
          inMultiCalendar={true}
          onOtherPharmacyChange={(pharmacyId) => this.changeSecondPharmacy(pharmacyId, true)}
          onDutyToSendToAnotherPharmacy={this.onDutySentToPharmacy}
          dutySentToAnotherPharmacy={this.state.dutyToSendToAnotherCalendar}
          onDutySentConsumed={this.eraseDutyToSendToAnotherCalendar}
          otherPharmacyBusyDates={this.state.secondPharmacyBusyDates}
          setPharmacyBusyDates={this.setFirstPharmacyBusyDates}
          onPharmacyIdChanged={this.props.onFirstPharmacyIdChanged}
        />
        <SimplePharmacyCalendar
          pharmacyId={this.state.startingSecondPharmacy}
          hideLegend={true}
          synchronizedScrolling={true}
          fly={this.state.selectedYear}
          onCalendarMove={this.onCalendarMove}
          onTypeChange={this.onTypeChange}
          selectedType={this.state.selectedType}
          inMultiCalendar={true}
          onOtherPharmacyChange={(pharmacy) => this.changeSecondPharmacy(pharmacy, false)}
          onDutyToSendToAnotherPharmacy={this.onDutySentToPharmacy}
          dutySentToAnotherPharmacy={this.state.dutyToSendToAnotherCalendar}
          onDutySentConsumed={this.eraseDutyToSendToAnotherCalendar}
          otherPharmacyBusyDates={this.state.firstPharmacyBusyDates}
          setPharmacyBusyDates={this.setSecondPharmacyBusyDates}
          onPharmacyIdChanged={this.props.onSecondPharmacyIdChanged}
          groupIdToLimitTo={
            this.props.PharmacyStore!.dataList.find(
              (ph) => ph.pharmacyId === this.props.UiStore!.multiCalendarFirstPharmacyId,
            ) === undefined
              ? undefined
              : this.props.PharmacyStore!.dataList.find(
                (ph) => ph.pharmacyId === this.props.UiStore!.multiCalendarFirstPharmacyId,
              )!.groupId
          }
        />
        <div id={'anchor'} ref="anchor" />
      </div>
    );
  }
}

export default withTranslate(MultiCalendarsForComparison);
